import axios from 'axios';
import { NEUTRAL_SIGNAL_BOUNDING_BOX_COLOR_HEX } from '@/constants/colors';

export default {
  state: {
    isLoading: false,
    documents: {},
  },
  actions: {
    getHighlighterBoundingBoxes(context, { customerId, documentId }) {
      return axios
        .get(
          `/api/v2/customers/${customerId}/documents/${documentId}/highlighter`,
        )
        .then((response) => {
          context.commit('setHighlighterDocument', {
            documentId,
            pages: response.data,
          });

          return response;
        });
    },
  },
  mutations: {
    setHighlighterLoading(state, loading) {
      state.isLoading = loading;
    },
    setHighlighterDocument(state, { documentId, pages }) {
      state.documents[documentId] = pages.map((page) => {
        return page.bounding_box_groups.flatMap((boundingBoxGroup) => {
          return boundingBoxGroup.bounding_boxes.map((boundingBox) => {
            return {
              color: NEUTRAL_SIGNAL_BOUNDING_BOX_COLOR_HEX,
              label: boundingBoxGroup.font,
              instance: {
                boundingBox,
                bounding_boxes: [boundingBox],
              },
            };
          });
        });
      });
    },
  },
};
